export default {
      id: "ic-home-graphique-usage",
      viewBox: "0 0 67 70",
      url: "../dist/images/" + "sprite.svg#ic-home-graphique-usage",
      toString: function () {
        return this.url;
      }
    }